import { Button, Drawer } from "antd";
import { useTranslation } from "react-i18next";
import { useAppContext } from "utils/context";
import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getUserFundData,
  postInquiryAmount,
} from "containers/services/services";
import { setUserFund } from "store/fund/action";
import { useNavigate } from "react-router-dom";
import {
  WebengageGeneralButtonEvent,
  handleClickMetrixEvents,
} from "containers/services/events.data";
import DrawerContent from "./drawerContent";

const LimitAmountDrawer = ({ open, handleDrawer }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { instance, metrixInstance } = useAppContext();
  const [loading, setLoading] = useState(false);
  const [inquiryAmount, setInquiryAmount] = useState({
    asset_amount: 0,
    min_amount: 0,
    remaining_required_amount: 0,
  });
  const dscode = process.env.REACT_APP_LIMIT_AMOUNT_DSCODE;
  const userFund = useSelector((state) => state?.fundReducer?.userFund);
  const prevMenu = useSelector((state) => state?.routerReducer?.prevMenu);

  const getFundInquiryAmount = async () => {
    setLoading(true);
    const { data: response } = await postInquiryAmount(instance, {
      onb_type: "BANK",
      destination_type: "MIDDLE_EAST",
    });
    if (response) setInquiryAmount(response);

    setLoading(false);
  };

  const getFundsDetail = useCallback(async () => {
    setLoading(true);
    const response = await getUserFundData(instance, dscode);
    if (response) {
      dispatch(setUserFund(response));
      getFundInquiryAmount();
    }
    setLoading(false);
  }, [instance, dscode, dispatch]);

  useEffect(() => {
    getFundsDetail();
  }, [getFundsDetail]);

  const onFundClick = async () => {
    navigate(`/funds/${dscode}`);
    await handleClickMetrixEvents(
      metrixInstance,
      "bank-limit-amout-modal-view-fund"
    );
    WebengageGeneralButtonEvent(
      "bank-button-limit-amount-modal-view-fund",
      prevMenu,
      "button",
      {
        "Object Id": dscode,
      }
    );
  };

  const handleFastInvest = async () => {
    navigate("/fast-invest");
    await handleClickMetrixEvents(
      metrixInstance,
      "bank-limit-amout-modal-fast-invest"
    );
    WebengageGeneralButtonEvent(
      "bank-button-limit-amount-modal-fast-invest",
      prevMenu,
      "button"
    );
  };
  return (
    <Drawer
      title={t("card-page.card-rules")}
      placement={window.innerWidth < 768 ? "bottom" : "left"}
      open={open}
      key="bottom"
      onClose={() => handleDrawer(false)}
      className="limit-drawer"
      destroyOnClose={true}
      rootClassName={
        "[&>.ant-drawer-content-wrapper]:!h-full hhhooho [&>.ant-drawer-content-wrapper]:!transform-none"
      }
      footer={
        <Button
          onClick={() => handleFastInvest()}
          block
          className="primary-button-large justify-center "
        >
          {t("card-page.fast-invest")}
        </Button>
      }
    >
      <DrawerContent
        loading={loading}
        inquiryAmount={inquiryAmount}
        onFundClick={onFundClick}
        fundName={userFund?.fund_name}
      />
    </Drawer>
  );
};
export default LimitAmountDrawer;
